import React from 'react';
import { money, pounds, whole } from './format';

function Figure({ label, value, note }) {
    return (
        <div className="afe-figure">
            <dt className="afe-figure-label">{label}</dt>
            <dd className="afe-figure-value mb-1">{value}</dd>
            <dd className="afe-figure-note text-muted small mb-0">{note}</dd>
        </div>
    );
}

/**
 * The three numbers the partners asked for, each with what it stands on.
 *
 * The weight and value are optional on a listing, so a bare total is a figure
 * a coordinator cannot defend when asked what it covers; the note beside each
 * one says how many of the transfers it was summed from.
 */
function Headline({ totals, activeNow }) {
    const { transfers } = totals;
    return (
        <section aria-labelledby="report-headline" className="mb-4">
            <h3 id="report-headline" className="h6 visually-hidden">
                Impact
            </h3>
            <dl className="afe-figures mb-2">
                <Figure
                    label="Pounds diverted from the landfill"
                    value={pounds(totals.poundsDiverted)}
                    note={`from ${totals.transfersWithWeight} of ${transfers} transfers that carried a weight estimate`}
                />
                <Figure
                    label="Dollars saved"
                    value={money(totals.dollarsSaved)}
                    note={`from ${totals.transfersWithValue} of ${transfers} transfers that carried a value estimate`}
                />
                <Figure
                    label="Items transferred"
                    value={whole(totals.itemsTransferred)}
                    note={`across ${transfers} transfers`}
                />
            </dl>
            <p className="mb-0">
                <strong>{whole(activeNow)}</strong> listings active now, open
                for a request.
            </p>
        </section>
    );
}

export default Headline;
